/**
 * Shae JS updater
 *
 * Updates elements on Shape JS viewer
 *
 *
 */

var ShapewaysView = require('./ShapewaysView');
var $ = require('./../../sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var shapejsActionCreators = require('js/lib/actions/ShapeJSRT/actionCreators');

var shapejsParamUpdater = ShapewaysView.extend({

  swAttrs: {
    shapejsToggle: 'data-sw-shapejs-param-toggle',
    shapejsParamUpdater: 'data-sw-shapejs-param-updater',
    shapejsParamUpdaterValue: 'data-sw-shapejs-param-updater-value',
    shapejsViewerCreatorId: 'data-sw-shapejs-viewer-creator-id'
  },

  events: function() {
    var eventsHash = {'click' : 'updateParam'};
    eventsHash['click [' + this.swAttrs.shapejsToggle + ']'] =  'checkboxChange';
    return eventsHash;
  },

  updateParam: function() {
    var shapejsViewerCreatorId = this.$el.attr(this.swAttrs.shapejsViewerCreatorId),
      shapejsParam = this.$el.attr(this.swAttrs.shapejsParamUpdater),
      paramValue = this.$el.attr(this.swAttrs.shapejsParamUpdaterValue);
    if (!shapejsParam || !shapejsViewerCreatorId || !paramValue) {
      return;
    }
    var params = {};
    params[shapejsParam] = JSON.parse(paramValue);

    sw.dispatch(shapejsActionCreators.shapeJsViewerUpdateParams(shapejsViewerCreatorId, params));
  },

  checkboxChange: function(e) {
    var $el = $(e.currentTarget);
    var shapejsParam = $el.attr(this.swAttrs.shapejsToggle),
      shapejsViewerCreatorId = $el.attr(this.swAttrs.shapejsViewerCreatorId);
    if (!shapejsParam || !shapejsViewerCreatorId) {
      return;
    }
    var params = {};
    params[shapejsParam] = e.currentTarget.checked;

    sw.dispatch(shapejsActionCreators.shapeJsViewerUpdateParams(shapejsViewerCreatorId, params));
  }
});

module.exports = shapejsParamUpdater;
